import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";

import { callGet, callPost } from "../../http_client";

import {
  alertsFetchError,
  alertsFetchRequest,
  alertsFetchSuccess,
  readAlertError,
  readAlertRequest,
  readAlertSuccess,
  unreadAlertsFetchError,
  unreadAlertsFetchSuccess,
} from "./actions";
import { AlertsActionTypes } from "./types";

export function* handleAlertsFetch(action: ReturnType<typeof alertsFetchRequest>): SagaIterator {
  try {
    const res = yield call(callGet, "/alerts/list/", action.payload);
    yield put(alertsFetchSuccess(res.data));
  } catch (err) {
    yield put(alertsFetchError(err.message));
  }
}

export function* handleUnreadAlertsFetch(): SagaIterator {
  try {
    const res = yield call(callGet, "/alerts/list/unread/");
    yield put(unreadAlertsFetchSuccess({ items: res.data }));
  } catch (err) {
    yield put(unreadAlertsFetchError(err.message));
  }
}

export function* handleReadAlert(action: ReturnType<typeof readAlertRequest>): SagaIterator {
  try {
    const { id } = action.payload;
    yield call(callPost, `/alerts/read/${id}/`);
    yield put(readAlertSuccess({ id }));
  } catch (err) {
    yield put(readAlertError(err.message));
  }
}

function* watchAlertsSagas(): SagaIterator {
  yield takeLatest(AlertsActionTypes.UNREAD_LIST_FETCH_REQUEST, handleUnreadAlertsFetch);
  yield takeLatest(AlertsActionTypes.READ_ALERT_REQUEST, handleReadAlert);
  yield takeLatest(AlertsActionTypes.LIST_FETCH_REQUEST, handleAlertsFetch);
}

export default watchAlertsSagas;
